/**
 * @generated SignedSource<<1ba589d6a6e452814b11db6102ac8b75>>
 * @relayHash 843eef387f7f0cb53cf3fed2191cc36d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 769504860593365a143aeea3bd2de7134a061619ea7fbf34c3f188189dfb1e9f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RoadmapPageLoaderQuery$variables = {
  locationAri?: string | null;
  sourceAri: string;
};
export type RoadmapPageLoaderQuery$data = {
  readonly roadmaps: {
    readonly roadmapForSource: {
      readonly roadmapConfiguration: {
        readonly boardConfiguration: {
          readonly isSprintsFeatureEnabled: boolean | null;
          readonly " $fragmentSpreads": FragmentRefs<"ChildIssuesSchedulingPreview" | "ChildIssuesSchedulingToggle">;
        };
      };
    } | null;
  } | null;
};
export type RoadmapPageLoaderQuery = {
  response: RoadmapPageLoaderQuery$data;
  variables: RoadmapPageLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locationAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "locationARI",
    "variableName": "locationAri"
  },
  {
    "kind": "Variable",
    "name": "sourceARI",
    "variableName": "sourceAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "isSprintsFeatureEnabled"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RoadmapPageLoaderQuery",
    "selections": [
      {
        "concreteType": "RoadmapsQuery",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapDetails",
            "kind": "LinkedField",
            "name": "roadmapForSource",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "concreteType": "RoadmapConfiguration",
                  "kind": "LinkedField",
                  "name": "roadmapConfiguration",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "concreteType": "RoadmapBoardConfiguration",
                        "kind": "LinkedField",
                        "name": "boardConfiguration",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "FragmentSpread",
                            "name": "ChildIssuesSchedulingToggle"
                          },
                          {
                            "kind": "FragmentSpread",
                            "name": "ChildIssuesSchedulingPreview"
                          }
                        ]
                      },
                      "action": "THROW"
                    }
                  ]
                },
                "action": "THROW"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RoadmapPageLoaderQuery",
    "selections": [
      {
        "concreteType": "RoadmapsQuery",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapDetails",
            "kind": "LinkedField",
            "name": "roadmapForSource",
            "plural": false,
            "selections": [
              {
                "concreteType": "RoadmapConfiguration",
                "kind": "LinkedField",
                "name": "roadmapConfiguration",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "RoadmapBoardConfiguration",
                    "kind": "LinkedField",
                    "name": "boardConfiguration",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isChildIssuePlanningEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "childIssuePlanningMode"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "769504860593365a143aeea3bd2de7134a061619ea7fbf34c3f188189dfb1e9f",
    "metadata": {},
    "name": "RoadmapPageLoaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "315e874b325a4c87e0fd376eaa279ef0";

export default node;
